<template>
  <div
    v-if="!isLoading2"
    class="section"
  >
    <div class="columns is-centered">
      <div class="column is-11">
        <div class="columns">
          <div class="column has-text-centered">
            <h2 class="title is-2">
              Statements Submitted
            </h2>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-12">
            <div class="message is-success">
              <div class="message-body">
                All statements have been submitted. Thank you!
              </div>
            </div>
          </div>
          <div class="column is-12">
            <h3 class="title is-4">
              Statements Downloads
            </h3>
            <div class="subtitle is-6">
              Click on each button below to view and print each statement for your own records. Please note that you will also be able to view and download these forms from the initial <b>File Now</b> screen under each year.
            </div>
            <div class="preview-forms">
              <div class="columns">
                <template v-if="currentFiling.cityReceived === 'Y' && currentFiling.cityPdfUrl">
                  <div class="column is-2">
                    <a
                      :href="currentFiling.cityPdfUrl"
                      class="preview-link"
                      target="_blank"
                    >
                      <i class="far fa-file-pdf" />
                      City Form<br> Download
                    </a>
                  </div>
                </template>
                <template v-if="currentFiling.stateReceived === 'Y' && currentFiling.statePdfUrl">
                  <div class="column is-2">
                    <a
                      :href="currentFiling.statePdfUrl"
                      class="preview-link"
                      target="_blank"
                    >
                      <i class="far fa-file-pdf" />
                      State Form<br> Download
                    </a>
                  </div>
                </template>
                <template v-if="currentFiling.mayorReceived === 'Y' && currentFiling.mayorPdfUrl && showMayorForm">
                  <div class="column is-2">
                    <a
                      :href="currentFiling.mayorPdfUrl"
                      class="preview-link"
                      target="_blank"
                    >
                      <i class="far fa-file-pdf" />
                      Mayor Form<br> Download
                    </a>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="column is-12">
            <div class="message is-warning">
              <div class="message-body">
                <b>Note:</b> Submitted statements cannot be edited. A new, amendment statement must be submitted.
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column has-text-centered">
            <router-link :to="{ name: 'file-now' }">
              <button
                id="back-btn"
                type="button"
                class="button is-primary"
                value="Go Back To File Now"
              >
                Back to File Now
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { filerScreenHelpers } from '@/mixins/filerScreen';

export default {
  name: "ReviewStatements",
  mixins: [
    filerScreenHelpers,
  ],
  data() {
    return {
      currentFiling: {},
    };
  },
  async created () {
    await this.initialFetch();
    await this.initalAssign();
    this.$store.commit('loading', false);
  },
  methods: {
    async initialFetch () {
      let promises = [];
      return Promise.all(promises);
    },
    async initalAssign () {
      this.currentFiling = this.getCurrentFiling();
    },
  },
};
</script>
<style lang="scss" scoped>
  .preview-link {
    border: 1px solid #ccc;
    width: 100%;
    text-align: center;
    margin: 0 auto;
    padding: 30px 0;
    display: inline-block;
    &:hover{
      background-color: #fff;
    }
  }
  .preview-forms {
    .fa-file-pdf {
      display: block;
      margin-bottom: 10px;
      &:before {
        font-size: 30px;
        color: red;
      }
    }
  }
</style>
